/* eslint-disable react/jsx-pascal-case */
import styled from "styled-components";
import Layout_user from "../../../Component/UI/Layout_user";
import { Icon, RowView } from "../../../Component/style/common_style";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import LiveList from "./Component/LiveList";
import SideBar from "./Component/SideBar";
import TopBar from "../../../Component/UI/TopBar";
import { LiveListItem } from "../../../Component/Interface/Live";
import api2 from "../../../Component/axios_Interceptor/api2";
import url from "../../../Component/server";
import api from "../../../Component/axios_Interceptor/api";
import { useLocation } from "react-router-dom";

interface UserInfoProps {
  userid: string;
}

const SearchStore = () => {
  const location = useLocation();

  const searchText = location.state?.searchText;
  const Navigate = useNavigate();
  const goBack = () => {
    Navigate(-1);
  };

  // 스토어 검색
  const [text, setText] = useState("");
  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
  };

  // 데이터
  const [liveList, setLiveList] = useState<LiveListItem[]>([]);
  const [nextLiveList, setNextLiveList] = useState<LiveListItem[]>([]);
  const [searchOn, setSearchOn] = useState(false);
  const [userInfo, setUserInfo] = useState<UserInfoProps>();

  const search_live = async (store: string) => {
    try {
      const res = await api2.get(url.Communication_url.live_search, {
        params: {
          store: store,
          userid: userInfo?.userid,
        },
      });
      setLiveList(res.data.broadcasting);
      setNextLiveList(res.data.scheduled);
    } catch (error) {
      console.error(error);
    }
  };

  const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
    localStorage.getItem("key") !== null && setIsLogin(true);
  }, []);

  const get_user_info = async () => {
    if (isLogin) {
      const res = await api.get(url.Communication_url.user_info);
      setUserInfo(res.data);
    }
  };
  useEffect(() => {
    get_user_info();
  }, [isLogin]);

  useEffect(() => {
    if (searchText) {
      setText(searchText);
      setSearchOn(true);
      search_live(searchText);
    }
  }, [searchText]);

  return (
    <Layout_user>
      <TopBar title={"스토어 찾기"} />
      <SearchDiv>
        <Icon src={require("../../../Image/ic_find_white2.png")} />
        <SearchInput
          type="text"
          placeholder="스토어명을 입력해주세요."
          value={text}
          onChange={handleTextChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              // 검색어로 스토어 검색
              setSearchOn(true);
              search_live(text);
            }
          }}
        />
      </SearchDiv>

      {searchOn && (
        <div style={{ padding: 20 }}>
          <div
            style={{
              color: "#C6C6C6",
              marginTop: 30,
              fontSize: 16,
              fontFamily: "var(--font-Pretendard-Regular)",
            }}
          >
            검색 결과{" "}
            <span
              style={{
                color: "white",
                fontFamily: "var(--font-Pretendard-SemiBold)",
              }}
            >
              {liveList.length + nextLiveList.length}개
            </span>
            의 스토어를 찾았습니다.
          </div>
          <div
            style={{
              color: "white",
              marginTop: 30,
              fontSize: 18,
              fontFamily: "var(--font-Pretendard-SemiBold)",
            }}
          >
            라이브
          </div>
          {liveList.length > 0 ? (
            <LiveList
              liveList={liveList}
              isLive={true}
              search_live={search_live}
              search={text}
              isLogin={isLogin}
            />
          ) : (
            <NullDiv>스토어가 없습니다</NullDiv>
          )}
          <div
            style={{
              color: "white",
              marginTop: 65,
              fontSize: 18,
              fontFamily: "var(--font-Pretendard-SemiBold)",
            }}
          >
            라이브 예정
          </div>
          {nextLiveList.length > 0 ? (
            <LiveList
              liveList={nextLiveList}
              isLive={false}
              search_live={search_live}
              search={text}
              isLogin={isLogin}
            />
          ) : (
            <NullDiv>스토어가 없습니다</NullDiv>
          )}
        </div>
      )}
    </Layout_user>
  );
};

export default SearchStore;

const SearchDiv = styled.div`
  flex-direction: row;
  display: flex;
  background-color: #3a3939;
  border-radius: 8px;
  border: 1px solid #474747;
  width: 92%;
  height: 50px;
  justify-self: center;
  align-items: center;
  justify-content: flex-start;
  margin-top: 27px;
  padding: 12px;
  box-sizing: border-box;
`;

const SearchInput = styled.input`
  margin-left: 10px;
  font-size: 16px;
  color: #ffffff;
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
`;

const NullDiv = styled.div`
  width: 100%;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
